import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import { Flag, Eye, HeartHandshake, Sparkles } from "lucide-react";

/**
 * 🎯 Página “Misión y Visión” — Versión extendida
 */
const AboutMission = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      {/* 🧭 Contenedor principal */}
      <div className="flex flex-col gap-7.5">
        {/* 📘 Card principal */}
        <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
          {/* 🔹 Encabezado */}
          <div className="border-b border-stroke px-4 py-6 dark:border-strokedark sm:px-6 xl:px-9">
            <h3 className="text-lg font-semibold text-black dark:text-white flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-primary" />
              Misión y Visión
            </h3>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 max-w-3xl leading-relaxed">
              Nuestra razón de ser y el horizonte que guía cada desarrollo de
              <strong> Codenova POS</strong>: una plataforma creada para
              transformar la gestión empresarial mediante tecnología,
              innovación y compromiso real con nuestros clientes.
            </p>
          </div>

          {/* 🔸 Contenido */}
          <div className="p-4 sm:p-6 xl:p-9 flex flex-col gap-10">
            {/* 🌟 Misión */}
            <div className="flex flex-col sm:flex-row gap-5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <Flag className="h-6 w-6" />
              </div>

              <div>
                <h4 className="mb-2 text-base font-semibold text-black dark:text-white">
                  Misión
                </h4>
                <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Nuestra misión es <strong>impulsar la transformación digital</strong>
                  de las empresas a través de soluciones tecnológicas confiables, accesibles y modernas,
                  que optimicen sus procesos, ahorren tiempo y fortalezcan su crecimiento sostenible.
                </p>
                <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  En <strong>Codenova POS</strong> desarrollamos herramientas que integran
                  facturación electrónica, control de inventario, análisis de datos y gestión de ventas,
                  con el objetivo de <strong>simplificar la administración y potenciar la productividad</strong>.
                </p>
                <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Buscamos ser un aliado estratégico para cada cliente, ofreciendo tecnología
                  que no solo automatiza tareas, sino que crea valor y abre nuevas oportunidades
                  de desarrollo empresarial.
                </p>
              </div>
            </div>

            {/* 🚀 Visión */}
            <div className="flex flex-col sm:flex-row gap-5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <Eye className="h-6 w-6" />
              </div>

              <div>
                <h4 className="mb-2 text-base font-semibold text-black dark:text-white">
                  Visión
                </h4>
                <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Nuestra visión es consolidarnos como una de las plataformas de
                  gestión empresarial más completas, confiables y reconocidas de
                  Latinoamérica, brindando <strong>innovación constante</strong>,
                  <strong> soporte de excelencia</strong> y soluciones que se adaptan
                  a las exigencias del entorno digital y fiscal moderno.
                </p>
                <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Aspiramos a ser referentes en la digitalización de negocios,
                  promoviendo el uso inteligente de la tecnología como motor de
                  competitividad, transparencia y eficiencia en las empresas de la región.
                </p>
                <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  Cada línea de código, cada actualización y cada mejora tiene un propósito:
                  <strong> ayudar a las empresas a crecer de forma segura, ordenada y sostenible.</strong>
                </p>
              </div>
            </div>

            {/* 💡 Valores */}
            <div className="flex flex-col sm:flex-row gap-5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <HeartHandshake className="h-6 w-6" />
              </div>

              <div>
                <h4 className="mb-2 text-base font-semibold text-black dark:text-white">
                  Nuestros Valores
                </h4>
                <ul className="list-disc list-inside text-sm leading-relaxed text-gray-600 dark:text-gray-400 space-y-2">
                  <li>
                    <strong>Innovación constante:</strong> impulsamos mejoras
                    continuas en cada componente del sistema.
                  </li>
                  <li>
                    <strong>Transparencia:</strong> actuamos con claridad y
                    responsabilidad en cada decisión técnica y comercial.
                  </li>
                  <li>
                    <strong>Empatía y compromiso:</strong> entendemos las
                    necesidades reales de nuestros clientes y las convertimos en
                    soluciones efectivas.
                  </li>
                  <li>
                    <strong>Calidad y seguridad:</strong> garantizamos un
                    desarrollo robusto, confiable y alineado con los más altos
                    estándares tecnológicos.
                  </li>
                  <li>
                    <strong>Pasión por el servicio:</strong> trabajamos con
                    dedicación para ofrecer soporte ágil, humano y orientado a
                    resultados.
                  </li>
                </ul>
              </div>
            </div>

            {/* ✨ Mensaje final */}
            <div className="flex items-start gap-3 mt-2">
              <Sparkles className="h-5 w-5 text-primary shrink-0 mt-1" />
              <p className="text-sm italic text-gray-600 dark:text-gray-400 leading-relaxed">
                En <strong>Codenova POS</strong> creemos que la tecnología debe ser
                una herramienta que conecte a las personas, optimice los procesos y
                transforme positivamente la forma en que las empresas crecen, innovan
                y se relacionan con su entorno.
              </p>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default AboutMission;
